module.exports = __webpack_public_path__ + "img/user-04.47582168.png";